import { agentTypeValues } from '../config/DataValues';

export const showODISModule = (agentType) => agentType === agentTypeValues.AGENTS;

export const showNuggetsModule = (agentType) => agentType === agentTypeValues.AGENTS;

export const showLenderMinutesModule = (agentType) => agentType === agentTypeValues.LENDERS;

export const showNrpPromoLinkModule = (agentType) => agentType === agentTypeValues.AGENTS;
